import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireforashavinayakdarshan() {



const cardData =
{
  keyword: 'Bus Hire for Ashtavinayak Darshan',
  heading: 'Sanavi Travels: Bus Hire for Ashtavinayak Darshan',
  headingDescription: 'Sanavi Travels offers reliable, comfortable, and well-organized Bus Hire for Ashtavinayak Darshan, specially designed for devotees, families, senior citizens, group pilgrims, corporate spiritual tours, and religious organizations planning the sacred Ashtavinayak Yatra. The Ashtavinayak circuit, which includes the eight revered Ganpati temples across Maharashtra, requires disciplined planning, safe driving, and comfortable long-distance travel due to varied routes, rural roads, ghats, and extended travel hours.',

  top: 'Sacred Travel Experiences with Bus Hire for Ashtavinayak Darshan',

  "topPlaces": [
    {
      "title": "Moreshwar Ganpati – Morgaon",
      "description": "Morgaon is the starting and concluding point of the Ashtavinayak Yatra and holds immense spiritual importance. Traveling by hired bus allows devotees to begin the pilgrimage together in a calm and organized manner. Comfortable group travel helps maintain discipline, ensures timely darshan, and sets a peaceful tone for the entire yatra."
    },
    {
      "title": "Siddhivinayak – Siddhatek",
      "description": "Siddhatek Ganpati is located on the banks of the Bhima River and involves rural road access and longer travel durations. A hired bus ensures safe navigation, comfortable seating for devotees, and stress-free travel, especially for senior citizens and large groups."
    },
    {
      "title": "Ballaleshwar – Pali",
      "description": "Pali’s Ballaleshwar temple is surrounded by scenic countryside and ghats. Bus hire for Ashtavinayak allows groups to travel safely through winding roads while enjoying a relaxed journey without worrying about driving fatigue or route planning."
    },
    {
      "title": "Varadvinayak – Mahad",
      "description": "Mahad is known for its peaceful temple atmosphere and continuous lamp inside the shrine. Group bus travel ensures devotees reach on time, rest comfortably between darshans, and maintain a smooth travel flow during the yatra."
    },
    {
      "title": "Chintamani – Theur",
      "description": "Theur Ganpati is closer to Pune and often visited by large groups in a single day. Hiring a bus allows devotees to avoid traffic stress, parking issues, and coordination problems while traveling together peacefully."
    },
    {
      "title": "Girijatmaj – Lenyadri",
      "description": "Lenyadri temple involves climbing steps and careful time management. Bus hire helps pilgrims conserve energy during travel, ensuring they arrive rested and prepared for the physical effort required at this sacred site."
    },
    {
      "title": "Vighnahar – Ozar",
      "description": "Ozar Ganpati is frequently visited along with Lenyadri. A hired bus allows efficient travel between temples, proper scheduling, and comfortable rest between darshans, enhancing the overall pilgrimage experience."
    },
    {
      "title": "Mahaganapati – Ranjangaon",
      "description": "Ranjangaon is often the final temple visited in the Ashtavinayak circuit. Bus hire ensures devotees complete the yatra together in a calm and organized manner, concluding the spiritual journey without travel fatigue."
    },
    {
      "title": "Multi-Day Ashtavinayak Yatra",
      "description": "Many groups prefer a 2–3 day Ashtavinayak Darshan to maintain a relaxed pace. Bus hire with overnight halts allows devotees to rest properly, manage temple timings comfortably, and experience a spiritually fulfilling journey."
    },
    {
      "title": "Peaceful & Disciplined Group Pilgrimage",
      "description": "Traveling together in a single bus fosters unity, discipline, and devotion among pilgrims, eliminating confusion, delays, and logistical challenges associated with multiple vehicles."
    }
  ],

  "services": [
    {
      "name": "Bus Hire for Ashtavinayak Darshan",
      "description": "Sanavi Travels provides complete bus hire solutions for Ashtavinayak Darshan, covering all eight Ganpati temples with well-planned routes, comfortable buses, and experienced drivers. Our service ensures peaceful, safe, and well-coordinated group pilgrimage travel."
    },
    {
      "name": "AC Bus for Ashtavinayak",
      "description": "AC buses are ideal for long-distance and multi-day Ashtavinayak journeys, offering a cool and comfortable environment that reduces fatigue and ensures a relaxed travel experience for devotees of all ages."
    },
    {
      "name": "Non AC Bus Hire for Ashtavinayak",
      "description": "Non AC buses provide an economical option for devotional groups while maintaining safety, seating comfort, and reliability throughout the pilgrimage."
    },
    {
      "name": "Luxury Bus Hire for Ashtavinayak",
      "description": "Luxury buses with enhanced seating and smooth suspension are suitable for premium pilgrim groups, senior citizen yatras, and corporate spiritual tours seeking added comfort."
    },
    {
      "name": "Mini Bus for Ashtavinayak Darshan",
      "description": "Mini buses are perfect for small families and private groups, offering flexibility, easier maneuvering on rural roads, and personalized travel schedules."
    },
    {
      "name": "32 Seater Bus for Ashtavinayak",
      "description": "32 seater buses are ideal for medium-sized devotional groups, balancing seating capacity with comfort for long yatra routes."
    },
    {
      "name": "35 Seater Bus Hire Ashtavinayak",
      "description": "35 seater buses cater to larger groups, mandals, and temple committees, ensuring organized and disciplined group travel."
    },
    {
      "name": "Bus with Driver for Ashtavinayak",
      "description": "All buses include experienced drivers familiar with Ashtavinayak routes, temple access roads, and safe highway driving, ensuring timely and secure travel."
    },
    {
      "name": "Affordable Bus Rental Ashtavinayak",
      "description": "We offer budget-friendly packages for Ashtavinayak Darshan without compromising on safety, cleanliness, or travel comfort."
    },
    {
      "name": "Outstation Bus Hire Ashtavinayak",
      "description": "Outstation bus services support devotees traveling from Pune, Mumbai, and nearby regions for complete Ashtavinayak Yatra with planned halts and smooth coordination."
    }
  ],

  "tableData": [
    ["Ashtavinayak Bus Hire", "AC Bus"],
    ["Non AC Bus", "Luxury Bus"],
    ["Mini Bus", "32 Seater Bus"],
    ["35 Seater Bus", "Outstation Travel"],
    ["Family Yatra", "Group Pilgrimage"]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "Experienced Pilgrimage Drivers",
      "WhyChoosedescription": "Drivers familiar with all Ashtavinayak routes, rural roads, and temple timings."
    },
    {
      "WhyChooseheading": "Comfortable Long-Distance Travel",
      "WhyChoosedescription": "Buses designed for extended journeys with relaxed seating and smooth rides."
    },
    {
      "WhyChooseheading": "Well-Planned Itineraries",
      "WhyChoosedescription": "Optimized routes covering all eight Ganpati temples efficiently."
    },
    {
      "WhyChooseheading": "Safe & Maintained Vehicles",
      "WhyChoosedescription": "Regular servicing, cleanliness, and safety checks before every yatra."
    },
    {
      "WhyChooseheading": "Flexible Multi-Day Packages",
      "WhyChoosedescription": "Custom plans based on group size, duration, and darshan preferences."
    },
    {
      "WhyChooseheading": "Transparent Pricing",
      "WhyChoosedescription": "Clear costs with no hidden charges for a worry-free pilgrimage."
    },
    {
      "WhyChooseheading": "Group-Friendly Travel",
      "WhyChoosedescription": "Entire group travels together, ensuring discipline and unity."
    },
    {
      "WhyChooseheading": "Trusted Pilgrimage Partner",
      "WhyChoosedescription": "Sanavi Travels is known for reliable religious tour transportation."
    }
  ]
};

const faqData = [
  { question: 'Do you provide bus hire for Ashtavinayak Darshan?', answer: 'Yes, Sanavi Travels offers complete bus hire services for Ashtavinayak Darshan.' },
  { question: 'Are AC buses available for Ashtavinayak Yatra?', answer: 'Yes, AC and Non AC buses are available based on your preference and budget.' },
  { question: 'Can the itinerary cover all eight Ganpati temples?', answer: 'Yes, we provide customized itineraries covering all eight Ashtavinayak temples.' },
  { question: 'Is the service suitable for senior citizens?', answer: 'Yes, our comfortable buses and experienced drivers make the yatra suitable for senior citizens.' },
  { question: 'Are drivers experienced with Ashtavinayak routes?', answer: 'Yes, our drivers are well-versed with pilgrimage routes and temple locations.' },
  { question: 'Can we plan a multi-day Ashtavinayak trip?', answer: 'Yes, multi-day yatra packages with overnight halts are available.' },
  { question: 'Do you offer affordable bus rental options?', answer: 'Yes, we offer budget-friendly packages for devotional groups.' },
  { question: 'Is advance booking recommended?', answer: 'Yes, advance booking is advised, especially during festival seasons.' },
  { question: 'Are buses cleaned before the trip?', answer: 'Yes, all buses are thoroughly cleaned and safety-checked before departure.' },
  { question: 'Can the bus be hired from Pune or Mumbai?', answer: 'Yes, we provide Ashtavinayak bus hire from Pune, Mumbai, and nearby regions.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Dattatray Kulkarni',
    feedback: 'Our Ashtavinayak Darshan with Sanavi Travels was very peaceful and well-organized. Comfortable bus and experienced driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Meena Joshi',
    feedback: 'Excellent service for our family Ashtavinayak Yatra. Safe travel and perfect route planning.',
    rating: 5
  }
];
















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];





const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire for Ashtavinayak Darshan - Sanavi Travels",
  "description": "Sanavi Travels offers buses for Ashtavinayak Darshan trips, including family travel, corporate trips, weddings, picnics, and outstation journeys. AC and Non-AC buses, mini buses, 32-seater and 35-seater options are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};










  return (
    <div>


<Helmet>
  <title>
    Call : +91 7387507373 | Bus Hire for Ashtavinayak Darshan | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book buses for Ashtavinayak Darshan with Sanavi Travels. AC & Non-AC mini buses, 32-seater and 35-seater buses for family travel, corporate trips, weddings, picnics, and outstation journeys with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/280.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushireforashavinayakdarshan;